const defaultPriceHistoryForm = {
    price: null,
    object_id: null,
    is_active: true,
}

export default defaultPriceHistoryForm;